export default __webpack_public_path__ + "select-97262567ab032b06346b75160223225b.mp3";